import React from 'react';
import Notificacao from '../Notificacoes/notificacao';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { PainelNotificacoes, Titulo, ContadorNovas, Notificacoes, HeaderNotificacoes, MensagemSemNotificacoes, Mensagem } from './styles';


const Painel = ({ anchorNotif, handleCloseNotif, notificacoes: rawNotificacoes }) => {
  const notificacoes = Array.isArray(rawNotificacoes) ? rawNotificacoes : [];
  const novas = notificacoes.filter((n) => !n?.seen).length;
  return (
    <div>
      <PainelNotificacoes
        anchorEl={anchorNotif}
        open={Boolean(anchorNotif)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        onClose={handleCloseNotif}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        keepMounted
      >

        <HeaderNotificacoes>
          <Titulo>Notificações</Titulo>
          {novas > 0 && (
            <ContadorNovas>{novas === 1 ? '1 nova' : `${novas} novas`}</ContadorNovas>
          )}
        </HeaderNotificacoes>

        <Notificacoes>
          {notificacoes.length === 0 ? (
            <MensagemSemNotificacoes>
              <NotificationsNoneOutlinedIcon sx={{ fontSize: 40 }} />
              <Mensagem>Você ainda não possui notificações</Mensagem>
            </MensagemSemNotificacoes>
          ) : (
            notificacoes.map((n, index) =>
              <Notificacao
                key={index}
                id={index}
                titulo={n?.title}
                descricao={n?.content}
                seen={Boolean(n?.seen)}
              />
            ))
          }
        </Notificacoes>

      </PainelNotificacoes >
    </div>
  );
};

export default Painel;
